import React from 'react'

import PagePersonalDashboard from 'components/PagePersonalDashboard'

const PageMy5Dynamics = () => <PagePersonalDashboard />

export default PageMy5Dynamics
